import { render, staticRenderFns } from "./cv-side-nav-items.vue?vue&type=template&id=7b7b776a&"
import script from "./cv-side-nav-items.vue?vue&type=script&lang=js&"
export * from "./cv-side-nav-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports